import React from 'react';
import { useIntl } from 'react-intl';
import messages from './FieldMessages';

const RelationCreated = () => {
  const intl = useIntl();
  return <span>{intl.formatMessage(messages.RelationCreated)}</span>;
};

export default RelationCreated;
